import {Injectable} from "@angular/core";
import gql from "graphql-tag";
import {VisbosService} from "../graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {Observable} from "rxjs/Observable";

export const keywordFragments = {
  keyword: gql`
    fragment KeywordFields on Keyword {
      cuid label is_editable
      created_at updated_at
      keyword search_string
    }`
};

export const FetchKeywordsQuery = gql`
  query Keywords($searchString: String) {
    keywords(search_string: $searchString) {
      ...KeywordFields
    }
  }
  ${keywordFragments.keyword}
`;

@Injectable()
export class KeywordService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public findKeywords(searchString?: string | Observable<string>): ApolloQueryObservable<{ keywords }> {
    return this.fetchItems({
      query: FetchKeywordsQuery,
      variables: {
        searchString: searchString
      },
      fetchPolicy: "network-only"
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/services/keyword.service.ts